module.exports = "beyond basics"


//////////////////
// WEBPACK FOOTER
// ./src/slides/12_beyond_basics/notes_1.md
// module id = 1535
// module chunks = 0